export const truncateValue = (value: any, maxCharCount?: number) => {
  if (maxCharCount && value.length > maxCharCount - 1) {
    return value.slice(0, maxCharCount)
  }
  return value
}
